module.exports = __webpack_public_path__ + "images/videoCaseStudy-berriFit-challenge-videoPoster.jpg?h=f33e22ddb07b33d308e6484fb4c71c77";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-challenge-videoPoster.jpg
// module id = 2096
// module chunks = 12 15